import { useTransferState } from 'pages/Transfer/Transfer.context'
import {
  TransferContactState,
  TransferGeneralState,
} from 'pages/Transfer/Transfer.stateMachine'

import { MFAError } from './MFAError'
import { MFASending } from './MFASending'
import { MFASuccess } from './MFASuccess'

interface MFATransferProps {
  handleNewTransfer: () => void
}
export const MFATransfer = ({ handleNewTransfer }: MFATransferProps) => {
  const {
    transferState: [state],
  } = useTransferState()

  if (
    state.matches(
      `${TransferGeneralState.ContactTransfer}.${TransferContactState.SendingMfa}`
    )
  ) {
    return <MFASending />
  }

  if (
    state.matches(
      `${TransferGeneralState.ContactTransfer}.${TransferContactState.MfaSuccess}`
    )
  ) {
    return <MFASuccess handleNewTransfer={handleNewTransfer} />
  }

  if (
    state.matches(
      `${TransferGeneralState.ContactTransfer}.${TransferContactState.MfaError}`
    )
  ) {
    return <MFAError />
  }

  return null
}
